export default [
    {
        path: "/app/:userDeptRoleId/office-config",
        components: {
            default: () => import("../views/office/office-config/index")
        },
        name: "office-config"
    },
];



// WEBPACK FOOTER //
// ./src/router/config-office.js